import React, { useContext } from 'react';
import Grid from '@material-ui/core/Grid';
import HandlingListInfoSection from './HandlingListInfoSection';
import HandlingListStatusSection from './HandlingListStatusSection';
import ShipmentsSection from '@afosto/app-components-react/ShipmentsSection';
import HandlingListContext from '../../../components/HandlingListContext';

const HandlingListDetails = () => {
  const { handlingList = {} } = useContext(HandlingListContext);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={7}>
        <HandlingListInfoSection />
      </Grid>
      <Grid item xs={12} md={5}>
        <HandlingListStatusSection />
      </Grid>
      <Grid item xs={12}>
        <ShipmentsSection shipmentIds={handlingList?.shipments} />
      </Grid>
    </Grid>
  );
};

export default HandlingListDetails;
